import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'reset-password-page';
export const useResetPasswordPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);
export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    error: {
      password_not_changed: 'Ошибка! Пароль не изменен!',
    },
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    password_not_changed: 'Error: the password has not been changed.',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    password_not_changed: 'Error: la contraseña no se ha cambiado.',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    password_not_changed: 'Erro: a senha não foi alterada.',
  },
}) : {}) as Record<string, unknown>;
